import BaseLogo from '@base/BaseLogo';
import useI18n from '@i18n';

import AuthActions from '../AuthActions';
import BurgerMenu from '../BurgerMenu';
import HeaderShell from '../Header';
import NavBar from '../NavBar';
import buildHeaderNavContext from '../../utils/buildHeaderNavContext';

interface IGuestHeaderProps {
    className?: string;
}

const GuestHeader: React.FC<IGuestHeaderProps> = ({ className }) => {
    const { locale } = useI18n();
    const navContext = buildHeaderNavContext(false, locale);

    return (
        <HeaderShell
            className={className}
            mobileNav={<BurgerMenu navContext={navContext} />}
            left={
                <>
                    <div className="shrink-0">
                        <BaseLogo link="/" />
                    </div>
                    <div className="flex-1 hidden h-full min-w-0 md:flex md:items-stretch">
                        <NavBar navContext={navContext} />
                    </div>
                </>
            }
            right={<AuthActions />}
        />
    );
};

export default GuestHeader;
